//new code update for carrer lattice 
import "./joblevel.css";
import Accordion from "../Accordion/Accordion";
import { useRef, useEffect, useState } from "react";
import {
  jobLevelCycle,
  userDataState,
  currentJobLevel,
  currentJobLevelData,
  careerWheelData
} from "../../atoms/dashboard";
import { useRecoilState, useRecoilValue } from "recoil";
import { Link } from "react-router-dom";
import PopOver from "../PopOver/PopOver";
import { myCareerWheel } from "../../selectors/dashboard";
//import { jobRole5? } from "./myCareerWheelData1?";
import { frmPage } from "../../atoms/dashboard";
const JobLevel = () => {
  const lineRef = useRef(null);
  const circleRef = useRef(null);
  const hoverCRef = useRef(null);
  const clickCRef = useRef(null);
  const levelRef = useRef(null);
  const innerText = useRef(null);
  const nextLevelRef = useRef(null);
  const currentLevelRef = useRef(null);
  const mainTextRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0)

  const [, setRoleInfo] = useRecoilState(jobLevelCycle);
  const [, setCurrenJobLevel] = useRecoilState(currentJobLevel);
  const [, setCurrentJobLevelData] = useRecoilState(currentJobLevelData)
  const [, setCareerWheelData] = useRecoilState(careerWheelData);
  const [,setFrmpg] = useRecoilState(frmPage);
  setFrmpg('dashboard');
  const accodionData = {
    title: "Role List",
    className: "joblist_accordion",
  };
  const usrApiData = useRecoilValue(userDataState);
  const currentJobLevelDataValue = useRecoilValue(currentJobLevelData);
  const myCareerWheelData1 = useRecoilValue(myCareerWheel);
  const jobRoleDataTrimmed = myCareerWheelData1?.filter((item, index, self) =>
    index === self.findIndex((t) => (
      t.level === item.level // Define your uniqueness criteria here
    ))
  );

  const sortedJobLevelData = jobRoleDataTrimmed.sort((a, b) => (a.level > b.level) ? 1 : ((b.level > a.level) ? -1 : 0));


  const myCareerWheelData = sortedJobLevelData;

  const lArray = [];
  myCareerWheelData?.forEach(function (item) {
    if (lArray.indexOf(item.level) === -1) lArray.push(item.level);
  });

  // check if the logindata matched careerdata
  const loginApiMatchCareerData = sortedJobLevelData.filter(data => data?.level == usrApiData?.jobLevelName)

  // check for current data
  const checkCurrentData = sortedJobLevelData.filter(data => data?.status == "Current");

  // check for previous data
  const checkPreviousData = sortedJobLevelData.filter(data => data?.status == "Previous");

  let currentJobLevelName;

  if (loginApiMatchCareerData.length > 0) {
    currentJobLevelName = loginApiMatchCareerData;
  } else if (checkCurrentData.length > 0) {
    currentJobLevelName = checkCurrentData
  } else if (checkPreviousData.length > 0) {
    currentJobLevelName = checkPreviousData
  } else {
    currentJobLevelName = [sortedJobLevelData[0]];
  }

  const unique = [...new Set(myCareerWheelData?.map(item => item.level))];

  const joblevelValue = unique.join()
    .split("L")
    .filter((item) => item !== "")
    .map((item) => parseInt(item, 10));

  function initialData() {
    let filtered = currentJobLevelName;
    return filtered;
  }
  const [filteredData, setFilteredData] = useState(initialData);

  const [levelNdPosition, setLevelNdPosition] = useState(currentJobLevelName);

  const [count, setCount] = useState(0);

  let levelNdDegree = [];

  let [firstJobLevelData] = sortedJobLevelData;
  const { level } = firstJobLevelData;
  let joinedLevel = parseInt(level?.split('L')[1]);
  let currentLevelData = myCareerWheelData1?.filter(data => data.level == currentJobLevelName[0].level);
  let currentLevel = parseInt(currentLevelData[0].level.split('L')[1]);


  console.log('currentLevel', currentLevel)

  const shouldShowGreyStroke = ((usrApiData?.jobLevelName != currentLevelData[0]?.level) && currentLevelData[0]?.status == "Future")

  const topLevel = 9;

  let totalLevel = joinedLevel == 1 ? topLevel : topLevel - joinedLevel + 1;
  let levels_show = topLevel - joinedLevel == 1 ? 2 : topLevel - joinedLevel;

  const drawstoke = currentLevel - joinedLevel;
  const grey_stoke = (754 / lArray.length) + "," + (655 - (754 / lArray.length))//655 - (750.5 / totalLevel) * (drawstoke + 1);
  const blue_stoke = 655 - (760.5 / totalLevel) * drawstoke;

  function generateSVG(value) {
    return document.createElementNS("http://www.w3.org/2000/svg", value);
  }
  function openPop(event) {
    document.querySelectorAll('.popup_data').forEach(function (elem) {
      elem.classList?.add('hidden');
    })
    document
      ?.getElementById(
        event.currentTarget.getAttribute("data-popover-target")
      )
      ?.classList?.toggle("hidden");
  }
  function drawLine(levelCount) {
    console.log('levelCountDrawline', levelCount)
    let drawLineAttr = [
      { key: "x1", value: "150" },
      { key: "y1", value: "0" },
      { key: "x2", value: "140" },
      { key: "y2", value: "0" },
    ];
    for (let i = 0; i < levelCount; i++) {
      let newLine = generateSVG("line");
      drawLineAttr.forEach((att) => {
        newLine.setAttribute(att.key, att.value);
      });
      lineRef.current?.append(newLine);
    }
  }

  function drawCircle() {
    if (count == 0) {
      let newCircleAttributes = [
        { key: "cx", value: "166" },
        { key: "cy", value: "0" },
        {
          key: "r",
          value: "15",
        },
        {
          key: "stroke",
          value: "#006298",
        },
        {
          key: "stroke-width",
          value: "2",
        },
        {
          key: "fill",
          value: "#ffffff",
        },
      ];
      let newCircle = generateSVG("circle");
      newCircleAttributes.forEach((att) => {
        newCircle.setAttribute(att.key, att.value);
      });
      circleRef.current?.append(newCircle);
    }
  }

  function drawCircleHover() {
    let newCircleAttributes = [
      { key: "cx", value: "166" },
      { key: "cy", value: "0" },
      { key: "r", value: "15" },
      {
        key: "stroke",
        value: "#006298",
      },
      {
        key: "stroke-width",
        value: "2",
      },
      {
        key: "fill",
        value: "#ffffff",
      },
      {
        key: "class",
        value: "hover-hidden",
      },
    ];
    let newCircle = generateSVG("circle");
    newCircleAttributes.forEach((att) => {
      newCircle.setAttribute(att.key, att.value);
    });
    hoverCRef.current?.append(newCircle);
  }

  function drawCircleClick() {
    let newCircle = generateSVG("circle");
    let newCircleAttributes = [
      { key: "cx", value: "166" },
      { key: "cy", value: "0" },
      { key: "r", value: "15" },
      {
        key: "stroke",
        value: "#006298",
      },
      {
        key: "stroke-width",
        value: "2",
      },
      {
        key: "fill",
        value: "#ffffff",
      },
      {
        key: "class",
        value: "circle-click-inactive",
      },
    ];
    newCircleAttributes.forEach((att) => {
      newCircle.setAttribute(att.key, att.value);
    });

    clickCRef.current?.append(newCircle);
  }

  function displayText(level, jobPosition) {
    let levelTextAttributes = [
      { key: "x", value: "300" },
      { key: "y", value: "205" },
      {
        key: "text-anchor",
        value: "middle",
      },
      {
        key: "stroke",
        value: "crimson",
      },
      {
        key: "stroke-width",
        value: "0.3",
      },
      {
        key: "alignment-baseline",
        value: "middle",
      },
      {
        key: "class",
        value: "level-text",
      },
    ];
    let positionElementAttributes = [
      { key: "x", value: "300" },
      { key: "y", value: "235" },
      {
        key: "text-anchor",
        value: "middle",
      },
      {
        key: "stroke",
        value: "#006298",
      },
      {
        key: "stroke-width",
        value: "0.3",
      },
      {
        key: "alignment-baseline",
        value: "middle",
      },
      {
        key: "class",
        value: "position-text",
      },
    ];
    let levelElement = innerText.current.querySelector(".level-text");
    if (!!levelElement) {
      levelElement.innerHTML = level;
    } else {
      let levelText = generateSVG("text");
      levelTextAttributes.forEach((att) => {
        levelText.setAttribute(att.key, att.value);
      });
      levelText.innerHTML = level;
      innerText.current?.append(levelText);
    }

    // let positionElement = innerText.current.querySelector(".position-text");

    // if (!!positionElement) {
    // positionElement.innerHTML = jobPosition;
    // } else {
    // let position = generateSVG("text");
    // positionElementAttributes.forEach((att) => {
    // position.setAttribute(att.key, att.value);
    // });
    // position.innerHTML = jobPosition;
    // innerText.current?.append(position);
    // }
  }

  function addText(levelCount, level) {
    let newTextAttributes = [
      { key: "x1", value: "150" },
      { key: "y1", value: "0" },
      { key: "x2", value: "140" },
      { key: "y2", value: "0" },
      {
        key: "text-anchor",
        value: "middle",
      },
      {
        key: "stroke",
        value: "#006298",
      },
      {
        key: "stroke-width",
        value: "0.3",
      },
      {
        key: "alignment-baseline",
        value: "middle",
      },
    ];
    if (count == 0) {
      console.log('level', level)
      for (let i = 0; i < levelCount; i++) {
        let newText = generateSVG("g");
        newTextAttributes.forEach((att) => {
          newText.setAttribute(att.key, att.value);
        });
        newText.innerHTML = `<text>` + "L" + level[i] + `</text>`;
        //let newTspan = generateSVG("tspan");
        //newTspan.innerHTML = newText;
        levelRef.current?.append(newText);
        if (level < 9) {
          level++;
        }
      }
    }
  }

  setInitialData();
  function setInitialData() {
    if (count == 0) {
      setRoleInfo(filteredData);
      console.log("filterdaa",filteredData);
    }
  }

  useEffect(() => {
    setCurrenJobLevel("current");
  }, [])

  useEffect(() => {
    setCount(count + 1)
    setCareerWheelData(jobRoleDataTrimmed)
  }, [])
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('plusCount')) {
      document.querySelectorAll('.popup_data').forEach(function (elem) {
        elem.classList?.add('hidden');
      })
    }
  })
  useEffect(() => {
    drawCircle();
    drawCircleHover();
    drawCircleClick();
    // drawLine(levels_show);
    drawLine(unique.length)
    // addText(levels_show, joinedLevel);
    addText(unique.length, joblevelValue)
    displayText(levelNdPosition[0].level, levelNdPosition[0].jobPosition);
    setCurrentJobLevelData(currentLevelData)

    const eachCircle = 360 / lArray.length;

    for (let i = 0; i < unique.length; i++) {
      let partDegree = eachCircle * i;
      let degree = partDegree + "deg";
      levelNdDegree.push({
        level: unique[i],
        degree: degree,
      });
      let j = i + 1;
      const levelChild = lineRef.current?.querySelector(`line:nth-child(${j})`);
      if (!!levelChild) {
        levelChild.style.transform = `rotate(${degree})`;
      }

      if (joinedLevel == currentLevel) {
        if (i == levels_show + 1) {
          const levelCircle = circleRef.current?.querySelector(
            `circle:nth-child(1)`
          );

          if (!!levelCircle) {
            levelCircle.style.transform = `rotate(${degree})`;
          }
        }
      } else {
        const levelCircle =
          circleRef.current.querySelector(`circle:nth-child(1)`);
        const levelDegree = levelNdDegree.filter(
          (val) => val.level.indexOf(currentLevel) != -1
        );
        if (levelDegree.length > 0) {
          if (levelCircle) {
            levelCircle.style.transform = `rotate(${levelDegree[0].degree})`;
          }
        }
      }

      const levelText = levelRef.current?.querySelector(`g:nth-child(${j})`);

      function changeCircle(e) {
        let levelCircleChange = hoverCRef.current?.querySelector(`circle`);
        levelCircleChange?.classList?.toggle("hover-hidden");
        levelCircleChange.style.fill = `white`;
        levelCircleChange.style.stroke = `#006298`;
        levelCircleChange.style.transform = `rotate(${degree})`;
      }

      levelText?.addEventListener("mouseover", changeCircle);

      function onMouseLeaveCircle(e) {
        let levelCircleChange = hoverCRef.current?.querySelector(`circle`);
        levelCircleChange?.classList?.toggle("hover-hidden");
      }

      levelText?.addEventListener("mouseleave", onMouseLeaveCircle);

      if (!!levelText) {
        levelText.style.cursor = "pointer";
        //levelText.style.transform = `rotate(${degree})`;
      }
      //levelText.style.transform = `rotate(90deg)`;
      levelText?.setAttribute('transform', 'rotate(' + (i * 360 / lArray.length) + ' 118 118)');
      levelText?.querySelector(`text`)?.setAttribute('transform', 'rotate(-' + ((i * 360 / lArray.length) + 45) + ')');
    }

    const levelTextElements = Array.from(levelRef.current?.childNodes);
    const lastChild = levelTextElements[levelTextElements.length - 1];

    if (
      (lastChild?.innerHTML == "L9" &&
        (joinedLevel == 9 ||
          (joinedLevel == 5 && currentLevel == 9) ||
          (joinedLevel == 6 && currentLevel == 9) ||
          (joinedLevel == 7 && currentLevel == 9) ||
          (joinedLevel == 8 && currentLevel == 9))) ||
      (joinedLevel == 2 && currentLevel == 9) ||
      (joinedLevel == 3 && currentLevel == 9) ||
      (joinedLevel == 4 && currentLevel == 9)
    ) {
      lastChild?.remove();
    }
  }, []);

  useEffect(() => {

    let jobLevelHeading = mainTextRef.current.querySelector(".job-level-text");
    let jobLevelText = innerText.current.querySelector(".level-text");
    let jobPositionText = innerText.current.querySelector(".position-text");

    if (((usrApiData?.jobLevelName != currentLevelData[0]?.level) && currentLevelData[0]?.status == "Future")) {
      jobLevelHeading.innerHTML = "Upcoming Job Level";
      jobLevelText?.classList?.add("upcoming-job-level");
      jobLevelHeading?.classList?.add("upcoming-job-level");
      jobPositionText?.classList?.add("upcoming-job-position");
      setCurrenJobLevel("upcoming");
    }


    function clickCircleFn(e) {
      let clickCircle = clickCRef.current?.querySelector(`circle`);

      if (!!clickCircle) {
        clickCircle?.classList?.remove("circle-click-inactive");
        clickCircle?.classList?.add("levelCircle-active");

        e.target?.classList?.add("levelText-active");

        let filteredLevelNdDegree = levelNdDegree.filter(
          (val) => val.level == e.target.innerHTML
        );

        clickCircle.style.transform = `rotate(${filteredLevelNdDegree[0]?.degree})`;

        let activeElements = [];
        let levelTextElements = Array.from(levelRef.current?.childNodes);
        levelTextElements.map((val) => {
          if (val.children[0].className.baseVal == "levelText-active")
            activeElements.push(val);
        });

        activeElements.forEach((val) => {
          if (val.children[0].innerHTML !== e.target.innerHTML) {
            val.children[0]?.classList?.remove("levelText-active");
          }
        });

        let filteredLevel = myCareerWheelData1?.filter(
          (val) => val.level == e.target?.innerHTML
        );


        if (((usrApiData?.jobLevelName != currentLevelData[0]?.level) && currentLevelData[0]?.status == "Future")) {
          jobLevelHeading.innerHTML = "Future Job Level";
          jobLevelText?.classList?.add("upcoming-job-level");
          jobLevelHeading?.classList?.add("upcoming-job-level");
          jobPositionText?.classList?.add("upcoming-job-position");
          setCurrenJobLevel("upcoming");
        } else if (currentLevel < e.target.innerHTML?.split("L")[1]) {
          jobLevelHeading.innerHTML = "Future Job Level";
          jobLevelText?.classList?.add("upcoming-job-level");
          jobLevelHeading?.classList?.add("upcoming-job-level");
          jobPositionText?.classList?.add("upcoming-job-position");
          setCurrenJobLevel("upcoming");
        } else {
          jobLevelHeading.innerHTML = "Current Job Level";
          jobLevelText?.classList?.remove("upcoming-job-level");
          jobLevelHeading?.classList?.remove("upcoming-job-level");
          jobPositionText?.classList?.remove("upcoming-job-position");
          setCurrenJobLevel("current");
        }

        setLevelNdPosition(filteredLevel);
        setCount(count + 1);
        setRoleInfo(filteredLevel);
        setCurrentJobLevelData(filteredLevel)
        console.log("filterdaa :", filteredLevel)
        setSelectedIndex(0)
        displayText(filteredLevel[0].level, filteredLevel[0].jobPosition);
      }
    }
    let levelTextOutside = levelRef.current?.querySelectorAll(`text`);
    levelTextOutside.forEach((value) => {
      value.addEventListener("click", clickCircleFn);
    });
  }, []);


  return (
    
    <div className="text-center w-1/2 overflow-auto"> 
    <div className="flex justify-end">
      <div className="mr-2"><span class="role-dot inline-block future bg-[#36A95D]"></span><span className="font-semibold text-[10px]">Future Role(s)</span></div>      
      <div className="mr-2"><span class="role-dot inline-block active bg-[#418aff]"></span><span className="font-semibold text-[10px]">Current Role(s)</span></div>
      </div>
      
      <div className="explore-opportunities-btn mx-auto pt-3 pb-3">
        <Link className="text-white hover:text-white" to="/explore-roles">
          <PopOver content="Compactable Roles" direction="bottom">
            <button className="bg-[#033d9b] text-white py-1 px-8 rounded-full font-medium text-xs mr-2 explrbtn">
            Compactable Roles
            </button>
          </PopOver>
        </Link>
        <Link className="text-white hover:text-white" to="/carrerlattice">
          <PopOver content="View Career Lattice" direction="bottom">
            <button className="bg-[#033d9b] text-white py-1 px-8 rounded-full font-medium text-xs carlatbtn">
            View Career Lattice
            </button>
          </PopOver>
        </Link>
        <svg
          width="380"
          height="400"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          className="Careerwheel"
          id="Careerwheel"
        >
          <g className="main">
            <circle
              cx="300"
              cy="200"
              r="138"
              stroke="#478efd"
              strokeWidth="2"
              fill="transparent"
            />
            <circle
              cx="300"
              cy="200"
              r="120"
              stroke="#ffffff"
              strokeWidth="8"
              fill="transparent"
              id="cir"
            />
             {lArray.length > 1 ? <circle
              cx="300"
              cy="200"
              r="120"
              // stroke="#c1c1c1"
              stroke={shouldShowGreyStroke ? "fff" : "#c1c1c1"}
              strokeWidth="8"
              fill="transparent"
              strokeDasharray={grey_stoke}
              //strokeDashoffset={grey_stoke}
              id="next-level"
              ref={nextLevelRef}
            /> :''}
            
           
            <circle
              cx="300"
              cy="200"
              r="120"
              stroke={joinedLevel == currentLevel ? "#fff" : "#033d9b"}
              strokeWidth="8"
              fill="transparent"
              strokeDasharray="655"
              strokeDashoffset={blue_stoke}
              id="current-level"
              ref={currentLevelRef}
            />
            <g id="main-text" ref={mainTextRef}>
              <text x="300" y="170" textAnchor="middle" className="job-level-text">
                {/* Current Job Level */}
                {((usrApiData?.jobLevelName != currentLevelData[0]?.level) && currentLevelData[0]?.status == "Future") ? "Upcoming Job Level" : "Current Job Level"}
                
              </text>
             
            </g>
            
            <g className="marks" id="level-line" ref={lineRef}></g>
            <g className="marks" id="level-circle" ref={circleRef}></g>
            <g className="marks" id="hover-circle" ref={hoverCRef}></g>
            <g className="marks" id="click-circle" ref={clickCRef}></g>
            <g className="marks cursor-pointer" id="level-text" ref={levelRef}></g>
            <g className="marks" id="inner-text" ref={innerText}></g>
            
          </g>
        </svg>
       
        {currentJobLevelDataValue.length > 0 &&  <Accordion clsName={accodionData.className} data={accodionData} body={<div className=" flex flex-wrap gap-y-4 items-center justify-around mt-0">
          <ul className="list-decimal bg-white p-4 rounded-md border-[1px] border-[#e9f0f7]" id="list-decimal-jblevl">
           <li style={{listStyle:"none"}}></li>
            {currentJobLevelDataValue.map((data, index, arr) => {
              {
                return <li onClick={() => {
                  setSelectedIndex(index)
                  setRoleInfo([data]);
                }}  className={`cursor-pointer text-left py-0 text-[14px] font-semibold jobLevelData text-gray-400 ${selectedIndex == index ? "active": ""}`}>{data?.jobPosition}</li>
              }
            })}
          </ul>
        </div>} from="job_Lvl" />
        }  
       
      </div>
    </div>
  );
};

export default JobLevel;


